import { find } from 'lodash';
import { missingTransactionTags } from '../data';

export default (tag) => find(missingTransactionTags, { value: tag });
